<template>
  <div class="page-login v-service-login">
    <div class="logo-container">
      <div class="logo">
        <van-image class="image"
                   fit="scale-down"
                   width="1.5rem"
                   height="1.5rem"
                   :src="$config.fileImg + logoUrl" />
      </div>
    </div>
    <div class="input-content">
      <div class="input-row">
        <div class="input-title">
          +86 <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <div class="input-flex">
          <input v-model="phone" placeholder="请输入您的手机号" />
        </div>
      </div>
      <div class="input-row">
        <div class="input-title">
          验证码
        </div>
        <div class="input-flex">
          <input v-model="phoneCode" maxlength="4" placeholder="请输入您的验证码" />
        </div>
        <button class="code-button"
             @click="obtainCode"
             style="color: #14CC80"
             :disabled="disabledSend">{{sendCode}}
        </button>
      </div>
    </div>
    <!-- <van-cell-group>

      <van-field v-model="phone"
                 label=""
                 label-width="58"
                 placeholder="手机号"
                 clearable
                 
                 style="font-size: 0.3rem">

        <div slot="label"
             @click="obtainCode"
             style="display: flex">
          +86 <i class="van-icon van-icon-arrow van-cell__right-icon">
            </i>
        </div>
      </van-field>

      <van-field v-model="phoneCode"
                 label=""
                 label-width="10"
                 center maxlength="4"
                 clearable
                 placeholder="验证码"
                 style="font-size: 0.3rem">

        <div slot="button"
             @click="obtainCode"
             style="color: #14CC80"
             :disabled="disabledSend">{{sendCode}}
        </div>

      </van-field>
    </van-cell-group> -->
    <div class="login-botton">
      <pi-button type="primary"
                 @click="doLogin"
                 block>登录</pi-button>
      <pi-button class="wx-login-container"
                 @click="wxLoginSub"
                 block><img src="../../assets/img/ic_wx_logo_green.png">微信登录</pi-button>
      <!-- <div class="button1" @click="doLogin">
        登录
      </div> -->
      <!-- <div class="wx-login-container"
           @click="wxLoginSub">
        <img src="../../assets/img/ic_wx_logo_green.png">
        微信登录
      </div> -->
    </div>
  </div>
</template>

<script>
import { Image, CellGroup, Field } from "vant";
import { getSmsCode,getOprLogo } from "../../common/api/index";
import preventBack from "../../common/forbidback";

export default {
  mixins: [preventBack], //注入禁止返回上一页
  name: "login",
  components: {
    [Image.name]: Image,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field
  },
  data() {
    return {
      sendCode: "获取验证码",
      phone: "",
      phoneCode: "",
      errorMessage: "",
      time: 60,
      disabledSend: false,
      oprPkId: "",
      qr: "",
      logoUrl: {}
    };
  },
  mounted() {
    //清除accountPkId
    this.$common.remove("accountPkId");
    // 获取运营商Id
    this.obtainOprPkId();

    let phoneInfo = this.$common.get(this.$config.localKeyLogin.phoneInfo);
    if (phoneInfo) {
      this.phone = phoneInfo.phone;
    }
    let errorMsg = this.$route.params.errorMsg;
    if (!this.$common.isEmpty(errorMsg)) {
      this.$toast(errorMsg);
    }
  },
  methods: {
    getOprLogo(){
      getOprLogo({
        oprPkId: this.oprPkId,
        appType: 1
      }).then(data => {
        if (data.status === this.$config.ajaxStatus) {
          this.logoUrl = data.data[0];
        }
      })
    },
    obtainOprPkId() {
      this.oprPkId = this.$common.query("oprPkId");
      if (this.$common.isEmpty(this.oprPkId)) {
        this.$dialog
          .alert({
            title: "没有运营商Id",
            confirmButtonText: "确认",
            confirmButtonColor: "#14CC80"
          })
          .then(() => {});
      }else{
        this.getOprLogo();
      }
    },
    wxLoginSub() {
      if (this.$common.isEmpty(this.oprPkId)) {
        this.$toast("运营商Id为空");
        return;
      }
      this.$common.remove(this.$config.localKeyLogin.loginInfo);
      this.$router.push({
        name: "wx-confirm",
        query: { oprPkId: this.oprPkId }
      });
    },
    timeDown() {
      let result = setInterval(() => {
        --this.time;
        this.sendCode = this.time + "s";
        if (this.time < 0) {
          clearInterval(result);
          this.disabledSend = false;
          this.sendCode = "获取验证码";
          this.time = 60;
        }
      }, 1000);
    },
    obtainCode() {
      if (this.phone.length <= 0) {
        this.$toast("手机号不能为空！");
        return;
      }
      if (!/^[1][3456789][0-9]{9}$/.test(this.phone)) {
        this.$toast("手机号格式不正确");
        return;
      }
      if (this.disabledSend) {
        return;
      }
      this.disabledSend = true;
      getSmsCode(
        {
          oprPkId: this.oprPkId,
          phoneNo: this.phone,
          bussType: this.$config.bussType.login
        },
        true
      )
        .then(data => {
          console.log(data);
          if (data.status === this.$config.ajaxStatus) {
            this.$toast("验证码发送成功");
            this.disabledSend = true;
            this.timeDown();
          } else {
            console.log(data.msg);
            this.$toast(data.msg);
            this.disabledSend = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.$toast("验证码发送失败");
          this.disabledSend = false;
        });
    },
    doLogin() {
      if (this.phone.length <= 0) {
        this.$toast("手机号不能为空！");
        return;
      }
      if (!/^[1][3456789][0-9]{9}$/.test(this.phone)) {
        this.$toast("手机号格式不正确");
        return;
      }
      if (!this.phoneCode) {
        this.$toast("请输入验证码");
        return;
      }
      if (this.$common.isEmpty(this.oprPkId)) {
        this.$toast("运营商Id为空");
        return;
      }
      this.$common.save(this.$config.localKeyLogin.loginInfo, {
        phone: this.phone,
        phoneCode: this.phoneCode,
        oprPkId: this.oprPkId
      });
      this.$common.save(this.$config.localKeyLogin.phoneInfo, {
        phone: this.phone
      });

      console.log(this.oprPkId);
      this.$router.replace({ name: "wx", query: { oprPkId: this.oprPkId,replace: true } });
    }
  }
};
</script>

<style lang="less" >
@import "../../assets/less/old/var.less";
.page-login {
  min-height: 100%;
  display: flex;
  flex-direction:column;
  .logo-container {
    .flex-center();
    align-items: flex-end;
    width: 100%;
    height: 4.14rem;
    background: url("../../assets/img/ic_login_top.png");
    background-size: 100% 100%;
  }
  .wx-login-container {
    // .flex-content-center();
    // align-items: center;
    text-align: center;
    // font-size: 0.26rem;
    color: #14CC80;
    margin-top: 0.2rem;
    img {
      width: 0.41rem;
      height: 0.32rem;
      margin-right: 0.2rem;
      vertical-align: middle;
    }
  }
  .login-botton {
    padding: 0.4rem 0.2rem;
  }
  .input-content{
    padding: 0.43rem 0.4rem ;
    flex: 1;
    .input-row{
      padding: 0.59rem 0 0.1rem 0;
      display: flex;
      border-bottom: 1px solid #DDDDDD;
      .input-title{
        font-size: 0.34rem;
        line-height: 0.48rem;
        color: #333;
        width: 1.3rem;
        i{
          vertical-align: bottom;
        }
      }
      .input-flex{
        flex: 1;
        padding-left: 0.2rem;
        input{
          font-size: 0.34rem;
          width: 100%;
          height: 0.48rem;
          border: none;
          background: transparent;
        }
      }
      .code-button{
        background: transparent;
        border: none;
        color: #14CC80;
        font-size: 0.34rem;
      }
    }
  }

  .logo {
    width: 1.7rem;
    height: 1.7rem;
    background: white;
    border-radius: 50%;
    margin-bottom: 0.2rem;
    .flex-center();
    .image .van-image__img{
      border-radius: 50%;
    }
  }
}
</style>
